import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const plannerBase = `${u}/planner`;
const depBase = `${u}/dependencies`;

export const getDependencies = (itemId) =>
  apiFetch(`${plannerBase}/${itemId}/dependencies`).then(r => r.ok ? r.json() : Promise.reject(r));

export const addDependency = (itemId, toItemId, relationshipType) =>
  apiFetch(`${plannerBase}/${itemId}/dependencies`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ toItemId, relationshipType })
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const removeDependency = (dependencyId) =>
  apiFetch(`${depBase}/${dependencyId}`, { method: "DELETE" });
